const mapValues = (values, label, valueKey) => {
    const valuesMapped = values.map((value) => {
        return {
            label: label ? value?.[label] : value?.name,
            value: valueKey ? value?.[valueKey] : value?.id
        }
    });
    return valuesMapped;
}

export default mapValues;